import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TaggableResourcePickupRoute } from 'src/app/data/model/taggable-resource-pickup-route';
import { BaseDialogComponent } from 'src/app/shared/base/base-dialog.component';
import { DialogParam } from 'src/app/shared/base/base-entity-list.service';
import { TaggableResourceRouteService } from '../../services/taggable-resource-route.service';
import { of, tap, catchError } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-taggable-resource-route-dialog',
  templateUrl: './taggable-resource-route-dialog.component.html',
  styleUrls: ['./taggable-resource-route-dialog.component.scss']
})
export class TaggableResourceRouteDialogComponent extends BaseDialogComponent<
  TaggableResourcePickupRoute,
  TaggableResourceRouteService,
  TaggableResourceRouteDialogComponent,
  DialogParam
>
implements OnInit
{
  groups$ = this.service.groups$;
  type$=this.service.type$;
  ods_id$ = this.service.ods_id$;
  list$ = this.service.list$;
  loading:boolean=false;


  constructor(
    @Inject(MAT_DIALOG_DATA) data: DialogParam,
    dialogRef: MatDialogRef<TaggableResourceRouteDialogComponent>,
    service: TaggableResourceRouteService
  ) {
    super(data, dialogRef, service);
  }

  ngOnInit(): void {
    if (this.data?.id) {
      this.service.load(this.data?.id);
    }
    this.service.loadGroup();
    this.service.loadContainerTypes();
    this.service.loadOdsId();
    this.service.loadLists();
  }

  destroy(): void {
    this.service.clearEntity$();
  }

  saveData(item:TaggableResourcePickupRoute) {
    this.loading=true;
    this.service
      .save({ ...this.data, ...item })
      .pipe(
        tap((result) => {
          this.dialogRef.close(result);
          this.service.clearError$();
        }),
        catchError((err) => {
          if (err.error) {
            this.service.setError$(err.error);
          }
          return of(null);
        })
      )
      .subscribe((result:any)=>{
        this.loading=false;
      });
  }
}